import axios from 'axios';

const BASE_URL = process.env.REACT_APP_URL_POS;

export const versionService = {
  checkVersion: async (currentVersion) => {
    try {
      const response = await axios.get(`${BASE_URL}/public/version-check`, {
        params: { version: currentVersion }
      });
      return response.data;
    } catch (error) {
      console.error('Error checking frontend version:', error);
      // Return a mock response that does not block the user in case of server failure during check
      return {
        success: false,
        data: {
          matches: true,
          update_required: false
        }
      };
    }
  }
};
